import { useState, useEffect, useRef } from 'react';

const useFormHook = (initialValues, onClose) => {
    const [formData, setFormData] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const modalRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Date picker poppers can be rendered in a portal (outside modalRef),
            // so clicks there must not close the modal.
            if (event.target?.closest?.('.react-datepicker-popper') || event.target?.closest?.('.datepicker-popper-overlay')) {
                return;
            }
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return {
        formData,
        errors,
        modalRef,
        handleInputChange,
        setFormData,
        setErrors
    };
};

export default useFormHook;